import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-sent',
  templateUrl: './reset-password-sent.component.html',
  styleUrls: ['./reset-password-sent.component.scss']
})
export class ResetPasswordSentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
